<template>
  <transition name="fade">
    <article v-if="isActive" class="message" :class="[type]">
      <header v-if="title" class="message-header">
        <div>{{ title }}</div>
        <button
          v-if="closable"
          type="button"
          class="delete"
          :aria-label="ariaCloseLabel"
          @click="close"
        >
          <d-icon icon="times" />
        </button>
      </header>
      <section class="message-body">
        <div class="media">
          <div v-if="hasIcon" class="media-left">
            <d-icon :icon="icon" />
          </div>
          <div class="media-content">
            <slot />
          </div>
        </div>
      </section>
    </article>
  </transition>
</template>

<script>
import MessageMixin from "@mixins/messageMixin.js";
import DIcon from "@components/DIcon.vue";

/**
 * @displayName DMessage
 */
export default {
  name: "DMessage",
  components: {
    DIcon,
  },
  mixins: [MessageMixin],

  props: {
    /**
     * @ignore
     */
    ariaCloseLabel: {
      type: String,
      default: "Close",
    },
  },
};
</script>

<style scoped>
.notification > .delete {
  right: 0.5rem !important;
  top: 0.5rem !important;
}

.message {
  display: block;
  background-color: #f5f5f5;
  border-radius: 4px;
  font-size: 1rem;
}

.message:not(:last-child) {
  margin-bottom: 1.5rem;
}

.media {
  align-items: flex-start;
  display: flex;
  text-align: left;
}

.message-body {
  border-bottom-right-radius: 0.25rem /* 4px */;
  border-bottom-left-radius: 0.25rem /* 4px */;
  border-color: #dbdbdb;
  border-style: solid;
  border-width: 1px;
  color: #4a4a4a;
  padding: 1.25em 1.5em;
}

.message-body:only-child {
  border-width: 0 0 0 4px;
  border-radius: 4px;
}

.message-header {
  padding-inline: 1rem;
  padding-block: 0.75rem;

  border-top-right-radius: 0.25rem /* 4px */;
  border-top-left-radius: 0.25rem /* 4px */;
  font-weight: 700;
  color: white;
  background-color: #4a4a4a;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.media-content {
  overflow-y: hidden;
  overflow-x: auto;
  flex-basis: auto;
  flex-grow: 1;
  flex-shrink: 1;
  text-align: left;
}

.message-header .delete {
  flex-grow: 0;
  flex-shrink: 0;
  margin-left: 0.75em;
  background-color: hsla(0, 0%, 4%, 0.2);
  border: none;
  border-radius: 290486px;
  cursor: pointer;
  pointer-events: auto;
  display: inline-block;
  height: 20px;
  max-height: 20px;
  font-size: 14px;
  max-width: 20px;
  min-height: 20px;
  min-width: 20px;
  outline: none;
  position: relative;
  vertical-align: top;
  width: 20px;
}

.message-header .delete svg {
  margin-top: 3px;
}

.message .media,
.notification .media {
  padding-top: 0;
  border: 0;
}

.message.error {
  background-color: #fff5f7;
}
.message.error .message-header {
  background-color: #ff3860;
  color: white;
}

.message.error .message-body {
  border-color: #ff3860;
  color: #cd0930;
}

.message.success {
  background-color: #f6fef9;
}
.message.success .message-header {
  background-color: #23d160;
  color: white;
}

.message.success .message-body {
  color: #0e301a;
  border-color: #23d160;
}

.message.info {
  background-color: #f5fafe;
}

.message.info .message-header {
  background-color: #167df0;
  color: white;
}

.message.info .message-body {
  border-color: #167df0;
  color: #115199;
}

.message.warning {
  background-color: #fffdf5;
}

.message.warning .message-header {
  background-color: #ffdd57;
  color: #3b3108;
}

.message.warning .message-body {
  border-color: #ffdd57;
  color: #3b3108;
}

.message.error {
  background-color: #fff5f7;
}

.message.error .message-header {
  background-color: var(--color-error);
  color: red;
}

.message.error .message-body {
  border-color: var(--color-error);
  color: red;
}
</style>
